import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IconCircleFilled } from "@tabler/icons-react";
import { URLS } from "utils/constants";
import { getStatusConfig } from "../utils/statusUtils";

const VehicleCard = ({ vehicle, statuses }) => {
  const navigate = useNavigate();
  const statusConfig = getStatusConfig(vehicle.status_id, statuses);

  const StatusIcon = ({ size = 14, color }) => {
    return <IconCircleFilled size={size} color={color} />;
  };

  return (
    <Card
      className="workshop-vehicle-card"
      style={{
        cursor: "pointer",
        transition: "all 0.2s",
        border: "1px solid #e5e7eb",
      }}
      onMouseEnter={(e) => {
        e.target.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.target.style.boxShadow = "none";
      }}
      onClick={() => navigate(`${URLS.v1.WORKSHOP}/vehicle/${vehicle.id}`)}
    >
      <div
        className="workshop-vehicle-card-header"
        style={{
          position: "relative",
          height: "120px",
          backgroundColor: "#f3f4f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          borderTop: `4px solid ${statusConfig.color}`,
        }}
      >
        <span
          className="fs-1 fw-bold workshop-vehicle-plate"
          style={{
            color: "#1f2937",
            padding: "12px 24px",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            letterSpacing: "2px",
            border: `2px solid black`,
          }}
        >
          {vehicle.plateNumber}
        </span>
        <div
          style={{
            position: "absolute",
            right: "16px",
            top: "8px",
          }}
        >
          <Badge
            className="d-flex align-items-center gap-1 p-1 fs-6"
            style={{
              color: "white",
            }}
            bg={statusConfig.variant}
          >
            <StatusIcon size={14} color="white" />
            {statusConfig.label}
          </Badge>
        </div>
      </div>
      <Card.Body>
        <div style={{ marginBottom: "16px" }}>
          <div
            className="d-flex justify-content-between mb-2 fs-6"
            style={{
              marginBottom: "8px",
            }}
          >
            <span className="text-muted">Service Terakhir:</span>
            <span
              style={{
                fontWeight: "500",
                color: statusConfig.color,
              }}
            >
              {new Date(vehicle.lastService).toLocaleDateString("id-ID")}
            </span>
          </div>
          <div className="d-flex justify-content-between mb-2 fs-6">
            <span className="text-muted">Service Berikutnya:</span>
            <span
              style={{
                fontWeight: "500",
                color: statusConfig.color,
              }}
            >
              {new Date(vehicle.nextService).toLocaleDateString("id-ID")}
            </span>
          </div>
        </div>

        <Button
          style={{
            width: "100%",
          }}
          variant={statusConfig.variant}
        >
          Service
        </Button>
      </Card.Body>
    </Card>
  );
};

export default VehicleCard;
